import { buttonChrome } from "@/components/ui/button";
import { ErrorPanel } from "@/components/ui/ErrorPanel";
import { requestBugReport } from "@/lib/support/bug-report-request";
import type { Crumb } from "./Header";
import { ClientsPageFrame } from "../clients/ClientsLayout";
import { CLIENTS_PATH } from "../clients/paths";
import { MaybeLink } from "./MaybeLink";

/**
 * Something the address names that is not there: by default an address nothing answers on, as a
 * stale bookmark or a typed path. Said so, with the way to the clients, rather than a silent trip
 * to the front page. `problem` names what was being opened, for the report.
 */
export function PageNotFound({
  title = "This page doesn't exist",
  reason = "The address may be out of date, or mistyped.",
  problem = "open an address",
  crumbs = [],
}: {
  title?: string;
  reason?: string;
  problem?: string;
  crumbs?: Crumb[];
}) {
  return (
    <ClientsPageFrame crumbs={crumbs}>
      <ErrorPanel
        title={title}
        reason={reason}
        onReport={() => {
          requestBugReport({ Problem: problem, Error: "not found" });
        }}
      >
        <MaybeLink
          to={CLIENTS_PATH}
          className={`inline-flex ${buttonChrome({ variant: "primary" })}`}
        >
          Go to your clients
        </MaybeLink>
      </ErrorPanel>
    </ClientsPageFrame>
  );
}
